import React, { useState } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import EmailForm from './components/email_form'
import PasswordForm from './components/password_form'
import AccountForm from './components/account_form'

const ManageLoginScreen: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<string>('email')

  return (
    <ScreenWrapper>
      <div className='min-h-full w-full rounded bg-surface-page'>
        <div className='flex w-full flex-row bg-background-chrome'>
          <button
            className={`flex flex-1 p-4 justify-center ${
              selectedTab === 'email' ? 'border-b-2' : ''
            } border-border-brand`}
            onClick={() => setSelectedTab('email')}
          >
            Email
          </button>

          <button
            className={`flex flex-1 p-4 justify-center ${
              selectedTab === 'password' ? 'border-b-2' : ''
            } border-border-brand`}
            onClick={() => setSelectedTab('password')}
          >
            Wachtwoord
          </button>

          <button
            className={`flex flex-1 p-4 justify-center ${
              selectedTab === 'account' ? 'border-b-2' : ''
            } border-border-brand`}
            onClick={() => setSelectedTab('account')}
          >
            Profiel
          </button>
        </div>

        <div className='p-8'>

          {selectedTab === 'email' && <EmailForm />}

          {selectedTab === 'password' && <PasswordForm />}

          {selectedTab === 'account' && <AccountForm />}
        </div>

      </div>
    </ScreenWrapper>
  )
}

export default ManageLoginScreen
